module.exports = __webpack_public_path__ + "static/media/pp.a31ac764.jpg";